export enum ClassificationErrorType {
    DefaultNotConfigured,
    DefaultNotFound
}
